import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    SidebarGroup: "",
    SidebarInventoryGroup: "",

};

const sidebarSlice = createSlice({
    name: "sidebar",
    initialState,
    reducers: {
        setSidebar: (state, action) => {
            state.SidebarGroup = action.payload;
            // When selecting a group in Hardware Manager, clear Inventory group selection
            if (action.payload) {
                state.SidebarInventoryGroup = "";
            }
        },

        setSidebarInventoryGroup: (state, action) => {
            state.SidebarInventoryGroup = action.payload;
            // When selecting a group in Inventory, clear Hardware Manager group selection
            if (action.payload) {
                state.SidebarGroup = "";
            }
        },

        clearAllSidebarSelections: (state) => {
            state.SidebarGroup = "";
            state.SidebarInventoryGroup = "";
        },
    },
});

export const { setSidebar, setSidebarInventoryGroup, clearAllSidebarSelections } = sidebarSlice.actions;
export default sidebarSlice.reducer;